import React from 'react';
import PropTypes from 'prop-types';
import TrashIcon from '@learningblocks/exp-constants/lib/Images/trash-icon.svg';
import {Image} from '@learningblocks/storybook-components';

/**
 * RemoveIcon: Component display the Remove NodeOption Icon.
 */
export function RemoveIcon({removeOption}) {
  return <Image src={TrashIcon} alt='removeIcon' onClick={removeOption} />;
}

RemoveIcon.propTypes = {
  /**
   * Function involked when clicked on
   * the icon
   */
  removeOption: PropTypes.func.isRequired,
};

RemoveIcon.defultProps = {};
